import { DashboardFiltrosDTO } from "@/interfaces/crm-dashboard";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listCrmDashboardConfigs(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_CONFIGS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardGeoareas(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_GEOAREAS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}


export function listCrmDashboardVisitors(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_VISITORS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardKPIs(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_KPIS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardKPIsVisitors(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_KPIS_VISITORS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardAdmKPIsVisitors(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_ADM_KPIS_VISITORS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardAdmKPIsVisitorsDaily(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_ADM_KPIS_VISITORS_DAYS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}
export function listCrmDashboardKPIsVisitorsDaily(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_KPIS_VISITORS_DAYS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardKPIsVisitorsDailyAvg(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_KPIS_VISITORS_DAYS_AVG, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}

export function listCrmDashboardKpisInstitutions(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_KPIS_INSTITUTIONS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}
export function listCrmDashboardAnalyticData(filters: DashboardFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_DASHBOARD_ANALYTICS, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  )
}